import { Wording } from '@/types';

export const LOVE_WORDING_EE: Wording = {
  components_header_media_content: 'Helid',
  components_header_media_1: 'Meditatsioonid',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Juhendid',
  components_header_text2: 'Blogi',
  components_header_members: 'liikmed',
  hero_text: 'Avastage armastus läbi tähtede',
  hero_button_text: 'Alustage oma reisi',
  components_ressources_section_title: 'ARMASTUS JA ASTROLOOGIA',
  components_ressources_subheader_text: 'Teie taevane tööriistakomplekt romantilise ülevaate saamiseks',
  components_ressources_span_text: 'Sukelduge meie taskuhäälingusaadete ja artiklite universumisse, mille keskmes on armastus, sodiaagiga ühilduvus ja kosmiline ühendus. Ükskõik, kas otsite hingesugulase selgust või dekodeerite oma suhtemustreid, juhivad meie ressursid teid tähtede kaudu sügavamale mõistmisele.',
  components_ressources_card_1_title: 'Zodiac armastusvestlused',
  components_ressources_card_1_text: 'Avastage südamlikke taskuhäälingusaadete episoode, süvenedes iga märgi emotsionaalsesse keelde, armastuse ühilduvusse, kirglikkusse ja suhete arengusse.',
  components_ressources_card_2_title: 'Armastuse blogi',
  components_ressources_card_2_text: 'Lugege teadmisi ja mõtteid selle kohta, kuidas iga märk armastab, ravib ja ühendab. Meie ajaveeb on teie teejuht astroloogilise armastuse juurde alates sünastriast kuni planetaarse romantikani.',
  components_ressources_link: 'Uurige edasi',
  components_notes_and_google_title_1: 'Romantiline astroloogia',
  components_notes_and_google_title_2: 'Armastuse harjumused',
  components_notes_and_google_title_3: 'Kuulajate armastuse peegeldused',
  components_review_google_text: 'Mida meie kuulajad ütlevad',
  media_content_section_title: 'LOVE & ZODIAAC PODCAST',
  media_content_section_subheader_text: 'Tõeline jutt kosmilisest romantikast',
  text_media_1: 'Häälestage sügavaid, paljastavaid episoode astroloogiliste vastete, emotsionaalsete mustrite ja romantilise dünaamika kohta.',
  text_media_2: '',
  media_content_section_button_more: 'Kuulake kohe',
  text2_section_title: 'BLOGI',
  text2_section_subheader_text: 'Astroloogilised armastuslood ja arusaamad',
  text2_section_button_more: 'Laadige rohkem',
  components_text1_section_title: 'JUHENDID',
  components_text1_subheader_text: '',
  components_text1_span_text: '',
  components_text1_card_1_title: '',
  components_text1_card_1_text: '',
  components_text1_card_3_title: '',
  components_text1_card_3_text: '',
  components_text1_card_2_title: '',
  components_text1_card_2_text: '',
  components_text1_link: '',
  components_footer_text: 'Lase tähtedel juhtida teie armastuslugu',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registreerimisnumber',
  components_footer_legal: 'Juriidiline',
  components_footer_terms: 'Tingimused',
  components_footer_privacy: 'Privaatsuspoliitika',
  button_load_more: 'Laadige rohkem',
  page_media_2_content_hero_text: '',
  page_media_content_menu_antistress: '',
  page_media_content_menu_mindfulness: '',
  page_media_content_menu_energyboost: '',
  page_media_content_menu_mantra: '',
  page_media_1_content_hero_text: 'Armastus ja sodiaak: taskuhäälingusaadete episoodid',
  page_media_content_menu_compatibility: 'Ühilduvus',
  page_media_content_menu_love: 'Armastus',
  page_text1_hero_text: '',
  page_text1_section_title: '',
  page_text1_subheader_text: '',
  page_text2_hero_text: 'Avastage armastust astroloogia kaudu',
  page_text2_section_title: 'Blogi',
  page_text2_subheader_text: 'Artiklid',
  enter_email_title: 'Jätkamiseks sisestage oma e-posti aadress',
  enter_email_placeholder_email: 'Meil',
  enter_email_button_enter: 'Sisestage',
  components_login_success_text: 'Sisselogimine õnnestus!',
  components_card_link_media_content: 'Kuulake kohe',
  components_card_link_text2_content: 'Lugege artikleid',
  components_card_link_text1_content: '',
  france: 'Prantsusmaa',
  cyprus: 'Küpros',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditatsioon',
  page_media_content_menu_all: 'Kõik',
};